import React, { Component, Fragment } from "react";
import { Table } from "react-bootstrap";
import moment from "moment";

import axios from "../../../services/axios-service";
import ConsoleLog from "../../../hoc/ConsoleLog/ConsoleLog";
import "./RecruiterManagement.css";
import MangeUser from "../../../components/Admin/ManageUser/ManageUser";
import { checkValidity } from "../../../shared/utility";
import Button from "../../../components/UI/Button/Button";
import ToastNotification from "../../../components/UI/ToastNotification/ToastNotification";
import admmoreIcon from "../../../assets/images/admin-more-vertical-rec.svg";
import SearchBox from "../../../components/UI/SearchBox/SearchBox";
import Icon from "../../../components/UI/Icon/Icon";
import searchIcon from "../../../assets/images/search-icon-aqua-blue.svg";
import TransferRecruiter from "../../../components/Admin/TransferRecruiter/TransferRecruiter";
import { connect } from "react-redux";
import Modal from "../../../components/UI/Modal/Modal";
import Loader from "../../../components/UI/Loader/Loader";

/**
 * @desc Recruiter Management
 * @version 0.1.0
 * @author Lakshmikanth V,Jamshith
 */

const initialRecruiteDetails = {
  firstName: "",
  lastName: "",
  userBhId: "",
  email: "",
  location: "",
  userCompanyId: 1,
  userType: 3
};
class RecruiterManagement extends Component {
  constructor() {
    super();
    this.state = {
      recruiters: [],
      recruiterDetails: { ...initialRecruiteDetails },
      errorPosition: [],
      addUserModal: false,
      isShowToast: false,
      toastMessage: null,
      toastVariant: null,
      toastId: null,
      updateUserModal: false,
      disableUpdateButton: false,
      recruiterSearchResults: [],
      searchParam: "",
      transferRecruiterModal: false,
      joblist: [],
      transferingJoblist: [],
      recJobTransferToEmail: "",
      allJobCheck: false,
      disableTransferButton: true,
      showMoreOption: false,
      moreOptionIndex: "",
      emailEvent: null,
      deleteUserModal: false,
      jobCount: "",
      activeSort: "dateAdded",
      sortType: "desc",
      loading: false
    };
    this.setWrapperRef = this.setWrapperRef.bind(this);
    this.handleClickOutside = this.handleClickOutside.bind(this);
  }

  componentDidMount() {
    this.getAllRecruiters();
    document.addEventListener("mousedown", this.handleClickOutside);
  }

  componentDidUpdate(nextProps, nextState) {
    //ConsoleLog("props",nextState.recruiters !== this.state.recruiters)
    if (nextState.recruiters !== this.state.recruiters) {
      this.setState({ sortType: "desc" });
    }
  }

  componentWillUnmount() {
    document.removeEventListener("mousedown", this.handleClickOutside);
  }

  setWrapperRef(node) {
    this.wrapperRef = node;
  }

  handleClickOutside = event => {
    if (
      this.wrapperRef &&
      !this.wrapperRef.contains(event.target) &&
      event.target.id !==
        ("more-option-update" || "more-option-delete" || "more-option-transfer")
    ) {
      this.setState({ showMoreOption: false });
    }
  };
  /**
   * @desc Function to open Add company Modal
   * @param event
   * @return null
   */
  openMoreOption = (e, index) => {
    e.preventDefault();
    this.setState({ showMoreOption: true, moreOptionIndex: index });
  };
  // componentDidUpdate(){
  //   this.getAllRecruiters();
  // }

  /**
   * @desc Get existing recruiters details
   * @param null
   * @return null
   */
  getAllRecruiters = () => {
    axios
      .get("/galaxy/user")
      .then(response => {
        if (response.data.length > 0) {
          const recruiters = response.data;
          this.setState({
            recruiters: recruiters,
            recruiterSearchResults: recruiters,
            searchParam: ""
          });
        }
      })
      .catch(error => {
        ConsoleLog("error", error);
      });
  };
  /**
   * @desc Handle add recruiter form details change in Modal
   * @param event
   * @return null
   */
  recruiterDetailsChange = e => {
    const name = e.target.id;
    let recruiterDetails = this.state.recruiterDetails;
    recruiterDetails[name] = e.target.value;
    let newErrorPosition = [];
    if (name === "email") {
      newErrorPosition = this.state.errorPosition.filter(
        errPosition =>
          errPosition !== "contactEmailEmpty" &&
          errPosition !== "contactEmailFormat" &&
          errPosition !== "UserExists" &&
          errPosition !== "userBhId"
      );
    } else {
      newErrorPosition = this.state.errorPosition.filter(
        errPosition => errPosition !== name && errPosition !== "userBhId"
      );
    }
    this.setState({ recruiterDetails, errorPosition: newErrorPosition });
  };

  pasteChange = e => {
    if (!checkValidity(e.clipboardData.getData("text/plain"), "isNumeric")) {
      e.preventDefault();
      let newErrorPosition = [...this.state.errorPosition];
      newErrorPosition = newErrorPosition.concat("userBhId");
      this.setState({ errorPosition: newErrorPosition });
    }
  };

  /**
   * @desc Function to open Add user Modal
   * @param event
   * @return null
   */
  onHandleAddRecruiter(e) {
    e.preventDefault();
    this.setState({ addUserModal: true });
  }

  /**
   * @desc Function to cancel Add user Modal
   * @param event
   * @return null
   */
  cancelAddRecruiter = e => {
    e.preventDefault();
    this.setState({
      addUserModal: false,
      updateUserModal: false,
      deleteUserModal: false,
      recruiterDetails: { ...initialRecruiteDetails },
      errorPosition: [],
      searchParam: ""
    });
  };
  /**
   * @desc Submit Add Recruiter user Details
   * @param event
   * @return null
   */
  KeyPressBullhornIdChange = e => {
    //ConsoleLog("value",e)
    var e = e || window.event; // for trans-browser compatibility
    var charCode = e.charCode || e.which || e.keyCode;
    if (charCode > 31 && (charCode < 47 || charCode > 57)) {
      e.preventDefault();
    }

    if (e.shiftKey) {
      e.preventDefault();
    }
  };

  onSubmitRecruiterDetails = e => {
    this.setState({ disableUpdateButton: true });
    e.preventDefault();
    if (
      this.state.recruiterDetails.firstName.trim() === "" ||
      this.state.recruiterDetails.email.trim() === "" ||
      this.state.recruiterDetails.lastName.trim() === "" ||
      !checkValidity(this.state.recruiterDetails.email, "isEmail") ||
      this.state.recruiterDetails.location.trim() === ""
    ) {
      let errorPosition = [];
      if (this.state.recruiterDetails.firstName.trim() === "") {
        errorPosition = errorPosition.concat("firstName");
      }
      if (this.state.recruiterDetails.lastName.trim() === "") {
        errorPosition = errorPosition.concat("lastName");
      }
      // if(!checkValidity(this.state.recruiterDetails.bullhornId,'isNumeric') || this.state.recruiterDetails.bullhornId.length > 15) {
      //   errorPosition = errorPosition.concat('bullhornId');
      // }
      if (this.state.recruiterDetails.location.trim() === "") {
        errorPosition = errorPosition.concat("location");
      }
      if (this.state.recruiterDetails.email.trim() === "") {
        errorPosition = errorPosition.concat("contactEmailEmpty");
      } else if (!checkValidity(this.state.recruiterDetails.email, "isEmail")) {
        errorPosition = errorPosition.concat("contactEmailFormat");
      }

      this.setState({
        errorPosition: errorPosition,
        disableUpdateButton: false,
        searchParam: ""
      });
    } else {
      let recruiterDetails = { ...this.state.recruiterDetails };
      recruiterDetails.userBhId =
        recruiterDetails.userBhId === "" ? null : recruiterDetails.userBhId;
      axios
        .post(
          recruiterDetails.userId
            ? "/galaxy/user/" + recruiterDetails.userId
            : "/galaxy/user",
          JSON.stringify(recruiterDetails)
        )
        .then(response => {
          // ConsoleLog("response",response.data)
          if (response.data.message == "success") {
            const toastMessage = this.state.addUserModal
              ? "User added successfully!"
              : this.state.updateUserModal
              ? "User account updated successfully!"
              : "";

            /* Logging Add new user */
            axios
              .post("/galaxy/user/activity", {
                email: recruiterDetails.email,
                activity: "USER_CREATED"
              })
              .then(resp => {})
              .catch(err => ConsoleLog(err));
            /* Logging Add new user */

            this.setState({
              addUserModal: false,
              isShowToast: true,
              toastMessage: toastMessage,
              toastVariant: "success",
              toastId: "tid" + new Date().getTime(),
              recruiterDetails: { ...initialRecruiteDetails },
              errorPosition: [],
              updateUserModal: false,
              disableUpdateButton: false,
              searchParam: ""
            });
            this.getAllRecruiters();
          } else {
            let errorPosition = [];
            if (response.data.message === "User Bullhorn ID already exists") {
              errorPosition = errorPosition.concat("BHIDExists");
            } else {
              errorPosition = errorPosition.concat("UserExists");
            }
            this.setState({
              errorPosition,
              disableUpdateButton: false,
              searchParam: ""
            });
          }
        })
        .catch(error => {
          ConsoleLog(error);
          throw error;
        });
    }
  };

  /**
   * @desc cloase toast notification
   * @param null
   * @return null
   */
  handleCloseToastNotification = () => {
    this.setState({
      isShowToast: false,
      toastMessage: null,
      toastVariant: null,
      toastAutoClose: false
    });
  };

  updateRecruiterDetails = recruiter => {
    this.setState({
      updateUserModal: true,
      recruiterDetails: { ...recruiter },
      showMoreOption: false
    });
  };

  deleteRecruiterDetails = recruiter => {
    this.setState({ showMoreOption: false, loading: true });
    axios
      .get("/galaxy/job/recruiter?userId=" + recruiter.userId)
      .then(response => {
        const jobCount = response.data.jobCount;
        this.setState({
          jobCount,
          deleteUserModal: true,
          recruiterDetails: { ...recruiter },
          loading: false
        });
      })
      .catch(error => {
        ConsoleLog(error);
        throw error;
      });
  };

  transferRecruiter = recruiter => {
    this.setState({ showMoreOption: false, loading: true });
    axios
      .get("/galaxy/job/recruiter?list=1&userId=" + recruiter.userId)
      .then(response => {
        //ConsoleLog("joblist",response)
        const joblist = response.data;
        this.setState({
          joblist: joblist,
          recruiterDetails: { ...recruiter },
          transferRecruiterModal: true,
          deleteUserModal: false,
          loading: false
        });
      })
      .catch(error => {
        ConsoleLog(error);
        throw error;
      });
  };

  closeTransferModal = () => {
    this.setState({
      transferRecruiterModal: false,
      recruiterDetails: { ...initialRecruiteDetails },
      allJobCheck: false,
      recJobTransferToEmail: "",
      errorPosition: [],
      transferingJoblist: []
    });
  };

  jobCheck = (event, job) => {
    const transferingJoblist = [...this.state.transferingJoblist];
    let NewtransferingJoblist = [];
    if (transferingJoblist.includes(job.jobid)) {
      NewtransferingJoblist = transferingJoblist.filter(
        currentjob => currentjob !== job.jobid
      );
    } else {
      NewtransferingJoblist = transferingJoblist.concat(job.jobid);
    }

    //ConsoleLog("new job array",NewtransferingJoblist)
    this.setState({ transferingJoblist: NewtransferingJoblist });
  };

  handleAllJobCheck = e => {
    let transferingJoblist = [];
    if (!this.state.allJobCheck) {
      transferingJoblist = this.state.joblist.map(job => job.jobid);
    }
    this.setState({
      transferingJoblist: transferingJoblist,
      allJobCheck: !this.state.allJobCheck
    });
  };

  transferEmailIdChange = e => {
    e.preventDefault();
    const disableTransferButton = e.target.value.trim() === "" ? true : false;
    const name = e.target.id;
    let newErrorPosition = [];
    this.setState({
      recJobTransferToEmail: e.target.value,
      disableTransferButton: disableTransferButton,
      errorPosition: newErrorPosition,
      emailEvent: e
    });
  };

  SubmitTransfer = e => {
    this.setState({ disableTransferButton: true });
    let errorPosition = [];
    if (
      this.state.recJobTransferToEmail.trim() === "" ||
      !checkValidity(this.state.recJobTransferToEmail, "isEmail")
    ) {
      if (this.state.recJobTransferToEmail.trim() === "") {
        errorPosition = errorPosition.concat("transferEmailEmpty");
      } else if (!checkValidity(this.state.recJobTransferToEmail, "isEmail")) {
        errorPosition = errorPosition.concat("transferEmailFormat");
      }
      this.setState({ errorPosition, disableTransferButton: false });
    } else {
      const transferDetails = {
        jobIds: this.state.transferingJoblist,
        recJobTransferFromId: this.state.recruiterDetails.userId,
        recJobTransferToEmail: this.state.recJobTransferToEmail,
        userName:
          this.props.adminDetails.user_fname +
          this.props.adminDetails.user_lname,
        userId: this.props.adminDetails.user_id
      };
      axios
        .post("/galaxy/job/transfer", JSON.stringify(transferDetails))
        .then(response => {
          // ConsoleLog("response",response.data)
          if (response.data.message == "success") {
            const joblist = this.state.joblist.filter(
              job => !this.state.transferingJoblist.includes(job.jobid)
            );
            this.setState({
              isShowToast: true,
              toastMessage:
                this.state.recruiterDetails.firstName +
                " " +
                this.state.recruiterDetails.lastName +
                "'s job(s)  transferred successfully to " +
                response.data.recJobTransferToFullname,
              toastVariant: "success",
              toastId: "tid" + new Date().getTime(),
              errorPosition: [],
              joblist: joblist,
              transferingJoblist: [],
              transferRecruiterModal: joblist.length === 0 ? false : true,
              disableTransferButton: false,
              allJobCheck: false,
              recJobTransferToEmail: ""
            });
          } else {
            let errorPosition = [];
            errorPosition = errorPosition.concat("UserNotExists");
            this.setState({
              errorPosition,
              disableTransferButton: false
            });
          }
        })
        .catch(error => {
          ConsoleLog(error);
          throw error;
        });
    }
  };

  deleteRecruiter = () => {
    const deleteDetails = {
      recruiterEmail: this.state.recruiterDetails.email,
      userName:
        this.props.adminDetails.user_fname + this.props.adminDetails.user_lname,
      userId: this.props.adminDetails.user_id
    };
    axios
      .delete("/galaxy/user/" + this.state.recruiterDetails.userId, {
        data: JSON.stringify(deleteDetails)
      })
      .then(response => {
        this.getAllRecruiters();
        this.setState({
          deleteUserModal: false,
          isShowToast: true,
          toastMessage: "User deleted successfully!",
          toastVariant: "success",
          toastId: "tid" + new Date().getTime(),
          recruiterDetails: { ...initialRecruiteDetails }
        });
      })
      .catch(error => {
        ConsoleLog(error);
        throw error;
      });
  };

  sortRecruiter = sortField => {
    const sortType =
      sortField === this.state.activeSort
        ? this.state.sortType === "asc"
          ? "desc"
          : "asc"
        : this.state.sortType;
    const recruiters = [...this.state.recruiterSearchResults];
    let sortedRecruiters = [];
    //ConsoleLog("before sort",(new Date(recruiters[0].userCreatedDate).getTime()));
    if (sortField === "dateAdded") {
      sortedRecruiters = recruiters.sort((a, b) => {
        const [firstDate, secondDate] = sortType === "desc" ? [b, a] : [a, b];
        return (
          new Date(firstDate.userCreatedDate).getTime() -
          new Date(secondDate.userCreatedDate).getTime()
        );
      });
    } else if (sortField === "firstName") {
      sortedRecruiters = recruiters.sort((a, b) => {
        const [nameA, nameB] =
          sortType === "desc"
            ? [b.firstName.toLowerCase(), a.firstName.toLowerCase()]
            : [a.firstName.toLowerCase(), b.firstName.toLowerCase()];
        if (nameA < nameB) return -1;
        if (nameA > nameB) return 1;
        return 0;
      });
    } else if (sortField === "lastName") {
      sortedRecruiters = recruiters.sort((a, b) => {
        const [nameA, nameB] =
          sortType === "desc"
            ? [b.lastName.toLowerCase(), a.lastName.toLowerCase()]
            : [a.lastName.toLowerCase(), b.lastName.toLowerCase()];
        if (nameA < nameB) return -1;
        if (nameA > nameB) return 1;
        return 0;
      });
    }

    this.setState({
      recruiterSearchResults: sortedRecruiters,
      activeSort: sortField,
      sortType: sortType
    });
    //ConsoleLog(" after sort",sortedRecruiters)
  };
  recruiterSearchHandler = e => {
    const searchParam = e.target.value;
    this.setState({ searchParam: searchParam });
    const recruitersList = [...this.state.recruiters];
    const recruiters = recruitersList.filter(
      recruiter =>
        recruiter.firstName.toLowerCase().includes(searchParam.toLowerCase()) ||
        recruiter.lastName.toLowerCase().includes(searchParam.toLowerCase()) ||
        (recruiter.firstName + " " + recruiter.lastName)
          .toLowerCase()
          .includes(searchParam.toLowerCase()) ||
        recruiter.email.toLowerCase().includes(searchParam.toLowerCase()) ||
        recruiter.location.toLowerCase().includes(searchParam.toLowerCase())
    );
    this.setState({ recruiterSearchResults: recruiters });
  };

  render() {
    const recruiters = [...this.state.recruiterSearchResults];
    return (
      <Fragment>
        {this.state.loading ? (
          <Loader className="reacruiter-management-loader" />
        ) : null}
        <Table striped condensed hover className="admin-rec-list-container-tbl">
          <thead className="admin-rec-list-container-head">
            <tr>
              <th colspan="7" align="right" className="add-recruiter">
                <SearchBox
                  icon={searchIcon}
                  isBorder={false}
                  iconPosition={"right"}
                  iconInside={false}
                  className={
                    this.state.searchParam.length > 0 ? "search-active" : ""
                  }
                  value={this.state.searchParam}
                  onChange={this.recruiterSearchHandler.bind(this)}
                  placeholder="Search Recruiters"
                />
                <Button
                  className="admin-add-recruiter-btn"
                  onClick={e => this.onHandleAddRecruiter(e)}
                >
                  + Add Recruiter
                </Button>
              </th>
            </tr>
            <tr className="admin-rec-list-container-tr-head">
              <th className="dateadded">
                Date Added
                <Icon
                  icon={
                    this.state.activeSort === "dateAdded"
                      ? this.state.sortType === "desc"
                        ? "down-arrow"
                        : "up-arrow-sort"
                      : "down-arrow-disabled"
                  }
                  className="rec-down-arrow"
                  onClick={() => this.sortRecruiter("dateAdded")}
                ></Icon>
              </th>
              <th className="fname">
                First Name
                <Icon
                  icon={
                    this.state.activeSort === "firstName"
                      ? this.state.sortType === "desc"
                        ? "down-arrow"
                        : "up-arrow-sort"
                      : "down-arrow-disabled"
                  }
                  className="rec-down-arrow"
                  onClick={() => this.sortRecruiter("firstName")}
                ></Icon>
              </th>
              <th className="lname">
                Last Name
                <Icon
                  icon={
                    this.state.activeSort === "lastName"
                      ? this.state.sortType === "desc"
                        ? "down-arrow"
                        : "up-arrow-sort"
                      : "down-arrow-disabled"
                  }
                  className="rec-down-arrow"
                  onClick={() => this.sortRecruiter("lastName")}
                ></Icon>
              </th>
              <th className="bhid">Bullhorn ID</th>
              <th className="email">Email</th>
              <th className="location">Location</th>
              <th className="rec-more-optionth"></th>
              {/*<th className="action">&nbsp;</th>*/}
            </tr>
          </thead>
          <tbody className="admin-rec-list-container-tblbody">
            {recruiters.length > 0 ? (
              recruiters.map((recruiter, index) => (
                <tr className="admin-rec-list-container-trbody">
                  <td className="dateadded">
                    {moment(recruiter.userCreatedDate).format("DD/MM/YYYY")}
                  </td>
                  <td className="fname">{recruiter.firstName}</td>
                  <td className="lname">{recruiter.lastName}</td>
                  <td className="bullhorn-id">{recruiter.userBhId}</td>
                  <td className="email">{recruiter.email}</td>
                  <td className="location">{recruiter.location}</td>
                  <td className="rec-more-optionth">
                    <div className="admin-more-container">
                      <span>
                        <img
                          src={admmoreIcon}
                          onClick={e => this.openMoreOption(e, index)}
                        />
                      </span>
                      {this.state.showMoreOption &&
                      this.state.moreOptionIndex === index ? (
                        <div
                          className="admin-more-options"
                          ref={this.setWrapperRef}
                        >
                          <div
                            className="more-option-update"
                            onClick={() =>
                              this.updateRecruiterDetails(recruiter)
                            }
                          >
                            {" "}
                            Update
                          </div>
                          <div
                            className="more-option-delete"
                            onClick={() =>
                              this.deleteRecruiterDetails(recruiter)
                            }
                          >
                            Delete
                          </div>
                          <div
                            className="more-option-transfer"
                            onClick={() => this.transferRecruiter(recruiter)}
                          >
                            Transfer
                          </div>
                        </div>
                      ) : (
                        ""
                      )}
                    </div>
                  </td>
                  {/*<td className="">{recruiter.userId}</td>*/}
                </tr>
              ))
            ) : (
              <React.Fragment>
                <tr className="admin-rec-list-container-trbody">
                  <td colspan="7" className="noresults">
                    {"No matching users were found"}
                  </td>
                </tr>
                <tr className="admin-rec-list-container-trbody"> </tr>
              </React.Fragment>
            )}
          </tbody>
        </Table>
        <MangeUser
          recruiterDetails={this.state.recruiterDetails}
          handleRecruiterDetailsChange={this.recruiterDetailsChange}
          handleKeyPressBullhornIdChange={this.KeyPressBullhornIdChange}
          submitRecruiterDetails={this.onSubmitRecruiterDetails}
          showAddUsermodal={this.state.addUserModal}
          handleCancelAddRecruiter={this.cancelAddRecruiter}
          errorPosition={this.state.errorPosition}
          showupdateUserModal={this.state.updateUserModal}
          disableUpdateButton={this.state.disableUpdateButton}
          handlePasteChange={this.pasteChange}
        />
        <TransferRecruiter
          recruiterDetails={this.state.recruiterDetails}
          showTransferRecruiterModal={this.state.transferRecruiterModal}
          closeTransferModal={this.closeTransferModal}
          joblist={this.state.joblist}
          errorPosition={this.state.errorPosition}
          handleJobCheck={this.jobCheck}
          transferingJoblist={this.state.transferingJoblist}
          recJobTransferToEmail={this.state.recJobTransferToEmail}
          SubmitTransfer={this.SubmitTransfer}
          handleTransferEmailIdChange={this.transferEmailIdChange}
          handleAllJobCheck={this.handleAllJobCheck}
          allJobCheck={this.state.allJobCheck}
          disableTransferButton={this.state.disableTransferButton}
        />
        {this.state.isShowToast ? (
          <ToastNotification
            isShowToast={this.state.isShowToast}
            message={this.state.toastMessage}
            variant={this.state.toastVariant}
            autoClose={this.state.toastAutoClose}
            onClose={this.handleCloseToastNotification}
            toastId={this.state.toastId}
          />
        ) : (
          ""
        )}
        <Modal show={this.state.deleteUserModal} className="rec-delete-modal">
          <div className="delete-modal-content">
            {this.state.jobCount > 0 ? (
              <div>You have to transfer all the jobs before deleting.</div>
            ) : (
              <div>
                Are you sure you want to <span>delete</span> this recruiter?
              </div>
            )}
          </div>
          <Button uistyle="lesser" onClick={this.cancelAddRecruiter}>
            Cancel
          </Button>
          <Button
            onClick={
              this.state.jobCount > 0
                ? () => this.transferRecruiter(this.state.recruiterDetails)
                : this.deleteRecruiter
            }
          >
            {this.state.jobCount > 0 ? "Transfer" : "Confirm"}
          </Button>
        </Modal>
      </Fragment>
    );
  }
}

const mapStateToProps = state => ({
  adminDetails: state.clientProfile.clientDetails
});

export default connect(mapStateToProps)(RecruiterManagement);



// WEBPACK FOOTER //
// ./src/container/Admin/RecruiterManagement/RecruiterManagement.js